import { EllipsedText, EmptyState, FlexColumn, FlexRow, Loading } from '@gorila-shared-ui/components';
import { HeadingXSmall, LabelMedium, LabelSmall } from 'baseui/typography';
import { useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getValidEventPositions } from '../../utils/gpt';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { useCamera } from '../map/hooks/useCamera';
import { GptEventDetailData } from './GptEventDetailData';
import GptTimeLineEvents from './GptTimeLineEvents';
import { useGptEventDetail } from './hooks/useGptEventDetail';

export function GptEventDetail() {
  const { theme, css, classes, concatenateClasses } = useStyles();
  const { event, loadingEvent } = useGptEventDetail();
  const [initialZoom, setInitialZoom] = useState(false);
  const { fitToLngLats } = useCamera();

  useUpdateEffect(() => {
    if (event && !initialZoom) {
      fitToLngLats(getValidEventPositions(event));
      setInitialZoom(true);
    }
  }, [event]);

  return (
    <FloatingCardContent flexible gap={theme.sizing.scale600}>
      {!event && !loadingEvent && <EmptyState title="No se pudo cargar el evento." />}
      {!event && loadingEvent && <Loading />}
      {event && (
        <>
          <FlexRow gap={theme.sizing.scale300}>
            <FlexRow classNames={concatenateClasses(classes.centeredStart, classes.flexible(1))}>
              <FlexRow gap={theme.sizing.scale200} classNames={classes.centeredStart}>
                <HeadingXSmall margin={0}>
                  <EllipsedText breakAll inline>
                    {event.ident}
                  </EllipsedText>
                </HeadingXSmall>
                <LabelMedium margin={0} color={theme.colors.contentSecondary}>
                  <EllipsedText breakAll inline>
                    {`- ${event.eventName}`}
                  </EllipsedText>
                </LabelMedium>
              </FlexRow>
            </FlexRow>
          </FlexRow>
          <FlexColumn gap={theme.sizing.scale300}>
            <GptEventDetailData event={event} />
          </FlexColumn>
          <FlexRow
            centered
            gap={theme.sizing.scale200}
            classNames={css({
              background: theme.colors.backgroundTertiary,
              padding: theme.sizing.scale200,
              borderRadius: theme.sizing.scale300,
              height: theme.sizing.scale1000,
              boxSizing: 'border-box',
            })}
          >
            <LabelSmall>
              <span style={{ color: theme.colors.contentSecondary }}>Estado:</span> {event.statusDisplay}
            </LabelSmall>
          </FlexRow>
          <GptTimeLineEvents />
        </>
      )}
    </FloatingCardContent>
  );
}
